var map = {
	"./lucky-tnc-cn.svg": 2388,
	"./term-condition-bm.svg": 2389,
	"./term-condition-cn.svg": 2390,
	"./term-condition-id.svg": 2391,
	"./term-condition.svg": 2392,
	"./term-footer-m.jpg": 2393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;